<template>
    <div class="footer">
        <div class="footer-inner">
            <div class="logo">
                <a href="http://www.sozdata.com/" target="_blank" rel="noopener noreferrer">
                    <img src="~@/assets/img/sz-footer-logo.png" alt="">
                </a>
            </div>
            <ul class="nav">
                <li>
                    <a href="http://www.sozdata.com/#/About" target="_blank" rel="noopener noreferrer">关于我们</a>
                </li>
                <li><a-divider type="vertical" /></li>
                <li>
                    <a href="http://www.sozdata.com/#/Product?side=1" target="_blank" rel="noopener noreferrer">产品介绍</a>
                </li>
                <li><a-divider type="vertical" /></li>
                <li>
                    <a href="http://www.sozdata.com/#/Service" target="_blank" rel="noopener noreferrer">项目服务</a>
                </li>
                <li><a-divider type="vertical" /></li>
                <li>
                    <a href="http://www.sozdata.com/#/Customiz" target="_blank" rel="noopener noreferrer">数据定制</a>
                </li>
            </ul>
            <div class="copy-right">
                京ICP备17041952号-2 京公网安备11010802029194
                <a-divider type="vertical" />
                Copyright©2019 北京搜知数据科技有限公司 版权所有
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
    .footer {
        font-size: 14px;
        background:#0c213f;
        height:55px;
        width:100%;
        min-width: 1200px;
        .footer-inner {
            width:1200px;
            height:55px;
            margin:0 auto;
            overflow: hidden;
            .logo {
                width:99px;
                height:29px;
                float:left;
                margin-top:13px;
                img {
                    width:99px;
                    height:29px;
                }
            }
            .nav {
                float:left;
                margin-left: -30px;
                li {
                    display: inline-block;
                    height:29px;
                    line-height: 29px;
                    margin:13px 2px 0;
                    a {
                        color:#fff;
                    }
                    .ant-divider-vertical {
                        border-left-color:#fff;
                    }
                }
            }
            .copy-right {
                color:#fff;
                float:right;
                line-height: 55px;
                .ant-divider-vertical {
                    border-left-color:#fff;
                }
            }
        }
        
    }
</style>